// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog.v-dialog--active .v-card__title{cursor:-webkit-grab;cursor:grab}.v-dialog.v-dialog--active.dragging,.v-dialog.v-dialog--active.dragging .v-card__title{cursor:-webkit-grabbing!important;cursor:grabbing!important}", ""]);
// Exports
module.exports = exports;
